import React from 'react'
import { SwitchButton } from '../../../../../atoms/SwitchButton'
import translate from 'core/translate'
import styles from '../CreateRoleSettings/styles'
import { MakeAction, Permission } from '../types'
import store from 'core/store'

interface Props {
    handleModerationPermissionsChange: (isChecked: boolean, moderationPermission: Permission) => void
    permission: Permission
    moderationPermission?: Permission
    actions: MakeAction
}

export const ModerationRoleSettings = ({
    handleModerationPermissionsChange,
    permission,
    moderationPermission,
    actions,
}: Props) => {
    const { company } = store.getState().user
    if (permission.name !== 'files' || !moderationPermission || !company || !company.contentModeration) {
        return null
    }
    const action = actions[moderationPermission.id]
    const isActive = action['update']?.active || false

    return (
        <div key="moderation_update" className={styles.createRoleSettingsHeaderWrapper}>
            <label htmlFor="moderation_update" className={styles.createRoleSettingsHeader}>
                <div>{translate('moderation')}</div>
                <SwitchButton
                    onChange={() => handleModerationPermissionsChange(!isActive, moderationPermission)}
                    checked={isActive}
                />
            </label>
        </div>
    )
}
